import React from 'react'
import ActivityProfilesList from '../ActivityProfilesList'

export default function MatchedProfiles() {
    return (
        <ActivityProfilesList
            title={'Matched Profiles'}
            url={'matchinterest'}
        />
    )
}

